<template>
  <b-card class="animated fadeIn">
    <b-row>
      <b-col>
        <b-dropdown class="source-dropdown" v-model="selectedItem">
          <span slot="button-content">
            {{selectedItem|capitalizeRemoveHyphen}}
            <i
              v-if="isSearchBusy"
              class="fa fa-spinner fa-pulse button-spinner"
            ></i>
          </span>
          <b-dropdown-item
            v-for="source in searchResults.results"
            :key="source.source_name"
            :value="source.source_name"
            @click="selectedItem = source.source_name"
          >{{source.source_name|capitalizeRemoveHyphen}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row v-if="selectedItem">
      <b-col lg="12">
        <CopayEPASourceItem :source_name="selectedItem"></CopayEPASourceItem>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import { SOURCE_SEARCH } from "@/store/copay-epa-source/actions.type";
  import CopayEPASourceItem from "@/views/CopayEPASourceItem";
  import { mapState } from "vuex";

  export default {
    name: "CopayEPAFSourceList",
    components: {
      CopayEPASourceItem
    },
    data() {
      return {
        selectedItem: null
      };
    },
    computed: {
      ...mapState({
        searchResults: state => state.copayepasource.searchResults,
        isSearchBusy: state => state.copayepasource.isSearchBusy
      })
    },
    watch: {
      searchResults(newVal, oldVal) {
        if (newVal && newVal.results && newVal.results.length > 0) {
          this.selectedItem = newVal.results[0].source_name;
        }
      }
    },
    methods: {
      getCriteria() {
        return {
          ...this.criteria,
          page: this.currentPage,
          size: this.size,
          sortDesc: this.sortDesc,
          sortBy: this.sortBy
        };
      }
    },
    created() {
      this.$store.dispatch(SOURCE_SEARCH);
      if (
        this.searchResults &&
        this.searchResults.results &&
        this.searchResults.results.length > 0
      ) {
        this.selectedItem = this.searchResults[0];
      }
    }
  };
</script>
<style lang="scss">
  .source-dropdown {
    button {
      width: 140px;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/CopayEPASourceList.vue